// The category Select's options carry the category's own permission defaults
// (see documentationCategoriesSearchList.ts's mapper) so the permissions
// checkboxes can be prefilled/reset without a separate lookup.
export type CategoryOption = {
  value: string;
  label?: string;
  allowDownload?: boolean | null;
  allowPrint?: boolean | null;
};

export type CategoryPermissionKey = 'allowDownload' | 'allowPrint';

// A checkbox left matching the selected category's default resolves to null
// ("follow the category"), so the document keeps tracking future changes to
// that category's defaults. Only a divergence from the category — or having
// no category at all — resolves to an explicit override.
export default function resolveCategoryPermissionOverride(
  category: CategoryOption | null | undefined,
  key: CategoryPermissionKey,
  value: boolean,
): boolean | null {
  return category && value === !!category[key] ? null : value;
}
